import styled from "styled-components";
import { rootFixedSize } from "styles/theme";

const PageWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  .btn-paganation {
    padding: ${rootFixedSize.pagenationBtnPadding};
    border-radius: ${rootFixedSize.pagenationBtnBorderRadius};
    background-color: ${props => props.theme.tablePageBtnBgColor};
    color: ${props => props.theme.rootTextColor};
    &:hover {
      background-color: ${props => props.theme.buttonAccent};
      color: ${props => props.theme.rootTextColor};
      cursor: pointer;
    }
    &.active {
      background-color: ${props => props.theme.buttonAccent};
      color: ${props => props.theme.rootTextColor};
    }
  }
  button {
    color: ${props => props.theme.rootTextColor};
    &:disabled {
      color: ${props => props.theme.readOnlyColor};
      cursor: auto;
    }
  }
`;

function Pagenation({ totalCount, total, limit, page, setPage, startButtonNum, setClickButton }:
  { totalCount: number, total: number, limit: number, page: number, startButtonNum: number, setPage: Function, setClickButton: Function }) {
  const buttonPerPage = limit; // 보여줄 페이지네이션 버튼 수
  const numPages = total; // 총 페이지 수
  
  // console.log(totalCount, page, limit);
  // DATA 수 가 해당 페이지의 수보다 적으면 1페이지로 이동
  // if (totalCount <= ((page-1) * limit)) {
  //   setPage(1);
  // }

  return (
    <PageWrap>
      {!numPages ? null : (
        <>
          {!(page <= buttonPerPage) && <button type="button" onClick={() => setClickButton('prev')}>Prev</button>}
          {Array.from({ length: numPages > buttonPerPage? buttonPerPage : numPages }).map((_, i) => {
            let pages = startButtonNum + i;
            return (
              (pages > numPages ? null : 
                <p key={i} className={`btn-paganation ${page === pages ? 'active' : ''}`} onClick={() => setPage(pages)}>{pages}</p>
              )
            )
          })}
          {!(page === numPages || (numPages - startButtonNum) < buttonPerPage) && <button type="button" onClick={() => setClickButton('next')} >Next</button>}
        </>
      )}
    </PageWrap>
  );
}

export default Pagenation;